import type { RefObject } from 'react';
import { useRef } from 'react';

import type { ReactCropperElement } from 'react-cropper';

export function useCropperRef(): RefObject<ReactCropperElement | null> {
	return useRef<ReactCropperElement | null>(null);
}
